import GenericDB from './generic-db';

export default class ActivitiesDB extends GenericDB {
  constructor() {
    super('activities');
  }

  // Here you can extend ActivitiesDB with custom methods
}
